import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowTriangleLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-triangle-left"><path d="M17.4654 4.18721C18.6123 3.61264 20 4.42612 20 5.73462V18.2651C20 19.5736 18.6123 20.3871 17.4654 19.8125L4.95962 13.5473C3.68013 12.9062 3.68013 11.0935 4.95962 10.4524L17.4654 4.18721Z" fill="currentColor"/></CentralIconBase>;
};

export default IconArrowTriangleLeft;
